import { render, staticRenderFns } from "./Algebra.vue?vue&type=template&id=1865b6e0&scoped=true"
import script from "./Algebra.vue?vue&type=script&lang=js"
export * from "./Algebra.vue?vue&type=script&lang=js"
import style0 from "../assets/main.css?vue&type=style&index=0&id=1865b6e0&prod&scoped=true&lang=css&external"
import style1 from "./Algebra.vue?vue&type=style&index=1&id=1865b6e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1865b6e0",
  null
  
)

export default component.exports